import { render } from "./timeline-skeleton.vue?vue&type=template&id=0e31705c&scoped=true"
import script from "./timeline-skeleton.vue?vue&type=script&lang=js"
export * from "./timeline-skeleton.vue?vue&type=script&lang=js"

import "./timeline-skeleton.vue?vue&type=style&index=0&id=0e31705c&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e31705c"]])

export default __exports__